import { useMentiSpring } from '@mentimeter/motion/spring';
import { animated, easings } from '@react-spring/web';

interface DotProps extends React.ComponentProps<typeof animated.g> {
  x: number;
  y: number;
  label: string;
  radius: number;
  color: string;
  borderColor: string;
  textColor: string;
  disableAnimations: boolean;
  opacity: number;
}

export const Dot = ({
  x,
  y,
  label,
  radius,
  color,
  borderColor,
  textColor,
  opacity,
  disableAnimations,
  ...rest
}: DotProps) => {
  const [springs] = useMentiSpring({
    from: {
      opacity: 0,
      transform: 'scale(0.8)',
    },
    to: {
      opacity: 1,
      transform: 'scale(1)',
    },
    config: { duration: 350, easing: easings.easeInOutQuart },
    immediate: disableAnimations,
  });

  return (
    <animated.g
      style={{
        ...springs,
        cursor: 'pointer',
        transformBox: 'fill-box',
        transformOrigin: 'center',
      }}
      {...rest}
    >
      <circle
        fill={color}
        r={radius}
        cx={x}
        cy={y}
        stroke={borderColor}
        strokeWidth={3}
        style={{
          transition: disableAnimations
            ? 'none'
            : 'strokeOpacity 0.2s, fill-opacity 0.2s',
          fillOpacity: opacity,
          transformBox: 'fill-box',
          transformOrigin: 'center',
          strokeOpacity: opacity,
          filter: 'drop-shadow(0px 2px 8px  #0000001F)',
        }}
      />

      <text
        x={x}
        y={y}
        textAnchor="middle"
        dominantBaseline="central"
        fill={textColor}
        style={{ fontSize: `${radius}px`, cursor: 'pointer' }}
      >
        {label}
      </text>
    </animated.g>
  );
};
